// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__4YE5z","emails":"CreateEditClinics_emails__I-i2n","emailTagLabel":"CreateEditClinics_emailTagLabel__2NNW6"};